import { useEffect, useState } from 'react';

export default function useLocalStorage(key, defaultValue) {
	const [value, setValue] = useState(() => {
		if (typeof window === 'undefined') return defaultValue;

		try {
			const storedValue = localStorage.getItem(key);
			return storedValue !== null ? JSON.parse(storedValue) : defaultValue;
		} catch {
			return defaultValue;
		}
	});

	useEffect(() => {
		const listener = (e) => {
			if (e.storageArea !== localStorage || e.key !== key) return;

			try {
				setValue(e.newValue !== null ? JSON.parse(e.newValue) : defaultValue);
			} catch {
				setValue(defaultValue);
			}
		};

		window.addEventListener('storage', listener);

		return () => window.removeEventListener('storage', listener);
	}, [key, defaultValue]);

	const setValueInLocalStorage = (newValue) => {
		setValue((currentValue) => {
			const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;

			try {
				localStorage.setItem(key, JSON.stringify(result));
			} catch {
				// quota exceeded or private mode
			}

			return result;
		});
	};

	return [value, setValueInLocalStorage];
}

// import { useEffect, useState } from 'react';

// // ----------------------------------------------------------------------

// export default function useLocalStorage(key, defaultValue) {
//   const [value, setValue] = useState(() => {
//     const storedValue = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
//     return storedValue === null ? defaultValue : JSON.parse(storedValue);
//   });

//   useEffect(() => {
//     const listener = (e) => {
//       if (typeof window !== 'undefined' && e.storageArea === localStorage && e.key === key) {
//         setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
//       }
//     };
//     window.addEventListener('storage', listener);

//     return () => {
//       window.removeEventListener('storage', listener);
//     };
//   }, [key, defaultValue]);

//   const setValueInLocalStorage = (newValue) => {
//     setValue((currentValue) => {
//       const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
//       if (typeof window !== 'undefined') localStorage.setItem(key, JSON.stringify(result));
//       return result;
//     });
//   };

//   return [value, setValueInLocalStorage];
// }
